<template>
  <div id="highlights" class="section section-odd bg-filter ">
    <div class="container">
      <h3 class="is-size-3 has-text-white">
        <router-link to="blog" class="has-text-white">
          {{ $t("highlights") }}
        </router-link>
      </h3>
      <br />
      <carousel
        :autoplay="true"
        :autoplayTimeout="2000"
        :loop="true"
        :navigationEnabled="true"
        :autoplayHoverPause="true"
        :scrollPerPage="true"
        :perPageCustom="[[320, 1], [480, 3], [768, 4]]"
        :perPage="5"
      >
        <slide v-for="(blog, index) in blogs" :key="index">
          <router-link
            class="column is-relative "
            :to="'noticia/' + blog.path"
            data-aos="zoom-in"
            data-aos-delay="20"
            data-aos-duration="500"
          >
            <div class="hover-card">
              <div class="is-3 is-paddingless ">
                <figure class="image">
                  <img
                    class="has-border-radius w100 blog-box-image"
                    v-bind:src="getImgUrl(blog.image)"
                    :alt="blog.image"
                  />
                </figure>
              </div>
              <div>
                <p class="has-text-white has-text-centered">
                  {{ blog.content[$i18n.locale].title }}
                </p>
              </div>
            </div>
          </router-link>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n.js";
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "Highlights",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      title: "highlights",
      blogs: [],
    };
  },
  mounted() {
    this.loadPost();
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/cepSuites/" + pic);
    },
    getDexkImg() {
      let lang = i18n.locale;
      return require(`@/assets/img/${lang}-deck.png`);
    },
    async loadPost() {
      this.blogs = [];
      await import("@/assets/post.json")
        .then((res) => {
          this.blogs = res.data;
        })
        .then(() => {
          this.blogs = this.blogs.filter((e) => e.status);
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>
<i18n>
{
  "es": {
    "highlights": "Destacados"
  },
  "en": {
    "highlights": "Highlights"
  },
  "pt": {
    "highlights": "Destacado"
  }
}
</i18n>
